const RICOS_VERSION = "10.109.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
